/**
 * Code to represent whether value is net (inclusive of tax) or gross.
 * tag: 416
 * @readonly
 * @enum {number} (int)
 */
export enum IncTaxInd {
  /** Net */
  Net = 1,
  /** Gross */
  Gross = 2,
}
